export const checkNotNull = data => {
    if (data === null || typeof data === 'undefined') return false;
    if (!data.toString()) return false;

    return true;
};
